module.exports = __webpack_public_path__ + "img/ring_y_i_0_1@3x.2102d960.png";